import React from 'react';
import { ArrowUpDown, SlidersHorizontal } from 'lucide-react';

interface PageSectionHeaderProps {
  title: string;
  lastUpdated?: string;
  onSort?: () => void;
  onFilter?: () => void;
  onMore?: () => void;
  showSort?: boolean;
  showFilter?: boolean;
  showMore?: boolean;
}

const PageSectionHeader: React.FC<PageSectionHeaderProps> = ({ title }) => {
  return (
    <div className="w-full border-b bg-white px-6 py-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <h2 className="text-2xl font-semibold text-darkPurple">{title}</h2>
      </div>
      <div className="flex items-center gap-6 text-sm font-medium text-darkPurple"></div>
    </div>
  );
};

export default PageSectionHeader;
